<template>
  <div
    class="edit z-[10] cursor-pointer"
    @click="handleClick"
    ref="referenceElementRef"
    v-click-outside="onClickOutside"
  >
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
        class="icon-md"
      >
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M3 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0m7 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0m7 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
          clip-rule="evenodd"
        ></path>
      </svg>
    </div>
  </div>

  <Teleport to="body">
    <div ref="popperElementRef" v-if="showPopper">
      <TaskItemEditPopper
        @rename="handleRename"
        @delete="handleDelete"
        @clone="handleClone"
        :taskId="taskId"
      />
    </div>
  </Teleport>
</template>
<script setup>
import { createPopper } from '@popperjs/core'
import { ClickOutside as vClickOutside } from 'element-plus'
import { ref, watch, onBeforeUnmount, nextTick } from 'vue'
import { useTaskStore } from '@/store/taskStore'

const taskStore = useTaskStore()
const emits = defineEmits(['rename', 'clone', 'delete'])
defineProps({
  taskId: {
    type: [String, Number],
    required: true,
    validator: (value) => {
      if (!value) {
        console.warn('taskId is required')
        return false
      }

      return true
    }
  }
})

const handleRename = () => {
  emits('rename')
  clearPopper()
}

const handleClone = () => {
  emits('clone')
  clearPopper()
}

const handleDelete = () => {
  emits('delete')
  clearPopper()
}

const showPopper = ref(false)
const referenceElementRef = ref(null)
const popperElementRef = ref(null)
const handleClick = () => {
  showPopper.value = !showPopper.value
}

const onClickOutside = (event) => {
  if (event.target.parentElement.id !== 'task-item-edit-popper') {
    clearPopper()
  }
}

const createPopperInstance = () => {
  taskStore.popperInstance = createPopper(referenceElementRef.value, popperElementRef.value, {
    placement: 'right',
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [-20, 20]
        }
      }
    ]
  })
}

const clearPopper = () => {
  showPopper.value = false
  taskStore.popperInstance?.destroy()
  taskStore.popperInstance = null
}

watch(showPopper, (value) => {
  if (value) {
    nextTick(() => {
      if (!taskStore.popperInstance) {
        createPopperInstance()
      } else {
        clearPopper()
        createPopperInstance()
      }
    })
  } else {
    clearPopper()
  }
})

onBeforeUnmount(() => {
  clearPopper()
})
</script>
<style lang="scss" scoped>
.edit {
  opacity: 0;
  pointer-events: none;
  transition: 0.15s;
}

.icon-md {
  stroke-width: 1.5;
}

.icon-md,
.icon-md-heavy {
  flex-shrink: 0;
  width: 18px;
}
</style>
